import type React from 'react';
import type { ReactNode } from 'react';
import type { Section } from '../../config/types';

interface SectionListWrapperProps {
  showSections: boolean;
  section: Section;
  sectionIndex: number;
  children: ReactNode;
  sectionAction?: ReactNode;
}
export const SectionListWrapper: React.FC<SectionListWrapperProps> = ({
  showSections,
  section,
  sectionIndex,
  children,
  sectionAction,
}) => {
  if (showSections) {
    const hasFastToggle = section.subsections.some((subsection) =>
      subsection.pages.some((page) => page.fastToggle),
    );
    return (
      <li
        key={section.slug}
        data-testid="overview-sectionList-section"
        className={hasFastToggle ? 'app-task-list__section--nil-return' : undefined}
      >
        <div className={hasFastToggle ? 'app-task-list__section-heading' : undefined}>
          <h2 className="govuk-heading-m" id={`section-${section.slug}`}>
            <span className="app-task-list__section-number">{sectionIndex + 1}.</span>
            {section.title}
          </h2>
          {sectionAction}
        </div>
        {section.subsections && <ol className="app-task-list__items">{children}</ol>}
      </li>
    );
  }
  return <>{children}</>;
};
interface DeclarationWrapperProps {
  showSections: boolean;
  children: ReactNode;
  sections: Section[];
  titleOverride?: string;
}
export const DeclarationWrapper: React.FC<DeclarationWrapperProps> = ({
  showSections,
  children,
  sections,
  titleOverride,
}) => {
  if (showSections) {
    return (
      <li>
        <h2 className="govuk-heading-m">
          <span className="app-task-list__section-number">{sections.length + 1}.</span>
          {titleOverride || 'Declaration'}
        </h2>
        <ol className="app-task-list__items">{children}</ol>
      </li>
    );
  }
  return <>{children}</>;
};
